import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-shared-form-error',
    styles: ['div {display: block;}'],
    templateUrl: 'shared-form-error.component.html'
})

export class SharedFormErrorComponent implements OnInit {

    @Input() msgError: string;
    @Input() isFieldInvalid: boolean;

    constructor() { }

    ngOnInit() { }
}
